import React, { Component } from 'react';
import logout from '../login/Logout';
import $ from 'jquery';
// import { DialogComponent } from '@syncfusion/ej2-react-popups';
import HamburgerMenu from './HamburgerMenu';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import cssu
import { Link } from 'react-router-dom';

class Header extends Component {

  constructor() {
    super(...arguments);
    this.dialogClose = () => {
      this.setState({ hideDeletePopup: false, showTicketStatusPopup: false, hideLogoutConfirmation: false, showTicketStatusOpenPopup: false, });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.dialogInstance.hide();
        this.setState({ createNewProjectPage: false });
        this.setState({ hideCommentAddedDialog: false });
        this.setState({ hideTicketGenerateDialog: false });
      }
    }],
      this.createProjectbutton = [{
        buttonModel: {
          content: 'OK',
          cssClass: 'e-flat',
          isPrimary: true,
        },
        'click': () => {
          this.state.createNewProjectPage = false;
          this.props.history.push('/project-plan-settings');
        }
      }],
      this.buttons = [{
        buttonModel: {
          content: 'Yes',
          cssClass: 'e-flat',
          isPrimary: true,

        },
        'click': props => {
          this.deleteProjectAPi(this.state.id, this.state.propsId)
        }
      }
        , {
        buttonModel: {
          content: 'No',
          cssClass: 'e-flat',
          isPrimary: true,
        },
        'click': () => {
          this.setState({ hideDeletePopup: false });
        }
      }],
      this.ticketStatusButton = [{
        buttonModel: {
          content: 'Yes',
          cssClass: 'e-flat',
          isPrimary: true,

        },
        'click': props => {
          this.updateTicketStatusApi(this.state.editedId, this.state.ticketDescription,
            this.state.ticketPriority, this.state.ticketStatus, this.state.ticketType,
            this.state.ticketTitle)
        }
      }
        , {
        buttonModel: {
          content: 'No',
          cssClass: 'e-flat',
          isPrimary: true,
        },
        'click': () => {
          this.setState({ hideDeletePopup: false, showTicketStatusOpenPopup: false, showTicketStatusPopup: false });
        }
      }];

    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.setState({ hideDeleteSuccessPopup: false });
      }
    }];

    this.logoutButton = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': (props) => {
        logout();
      }
    },
    {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({ hideLogoutConfirmation: false });
      }
    }];

    this.state = {
      data: [{
        domain: '',
        id: '',
        language: [],
        lastBuildTime: '',
        lastModifiedBy: '',
        lastModifiedDate: '',
        name: '',
        projectDescription: ''

      }],
      ticketData: [{
        title: '',
        description: '',
        ticketStatus: '',
        ticketPriority: '',
        ticketType: '',
        id: ''

      }],
      ticketInfo: [{
        ticketId: '',
        commentedByUserId: '',
        commentedByUserName: '',
        commentedByUserEmail: '',
        comment: '',
        commentType: '',
        commentTime: '',

      }],
      editedProjectId: "-1",
      dataUrl: '',
      fields: {},
      errors: {},
      languages: [],
      domains: [],
      dataFields: { text: 'name', value: 'code' },
      domainData: { text: 'name', value: 'code' },
      deletePropIndex: '',
      propsId: '',
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      hideDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      showTicketStatusOpenPopup: false,
      hideTicketGenerateDialog: false,
      showManageProjectStore: false,
      showCreateProjectPage: false,
      showRaiseTicketEditPage: false,
      showInvoiceManagePage: false,
      ticketTitle: '',
      ticketDescription: '',
      ticketFileName: '',
      ticketFileType: '',
      ticketImageFile: '',
      ticketPriority: '',
      ticketStatus: '',
      ticketType: '',
      lastModifiedDate: '',
      ticketCreatedDate: '',
      lastModifiedBy: '',
      showCreateProjectPage: false,
      showRaiseTicketEditPage: false,
      showInvoiceManagePage: false,
      ticketTitle: '',
      ticketDescription: '',
      ticketFileName: '',
      ticketFileType: '',
      ticketImageFile: '',
      ticketPriority: '',
      ticketStatus: '',
      ticketType: '',
      lastModifiedDate: '',
      createdDate: '',
      lastModifiedBy: '',
      selectedFile: null,
      imagePreviewUrl: null,
      isOpen: false,
      dataUrl: null,
      currentLogoId: '',
      result: null,
      hideDialog: false,
      hideCommentAddedDialog: false,
      showRaiseTicketPage: false,
      showPreviousTicketPage: false,
      showTicketStatusPopup: false,
      showMyAcountPopUp: false,
      hideLogoutConfirmation: false,
      invoices: [],
      invoiceSubtotal: "",
      invoiceGst: "",
      invoiceProjectname: "",
      displayInvoice: false,
      billingFromDate: "",
      billingToDate: "",
      paymentRecieved: false,
      paymentId: "",
      billingAmount: "",
      editedInvoiceId: "1e349120-aba0-11ea-87fb-1da1e01b7a49",
      paymentParams: [],
      paymentSuccessful: false,
      Date: "",
      walletBalance: 0,
      checkboxActive: true,
      userRoles: [],
      selectedUser: "",
      selectedUserRole: "",
      inactivityLimit: 10 * 60 * 1000,
      timeoutId: null,
      aboutModal: false,
      showAboutModal: false,
      showChangeLogModal: false,
      showDocumentationModal: false,
      routeUrl: ""
    }
    this.createdDate = '';
    this.domainVar = [],
      this.statusVar = [],
      this.editImageSrc = "./assets/images/edit2.png";
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    // this.escFunction = this.escFunction.bind(this);
    if (localStorage.getItem("user_details") == null) {
      window.location.href = "/my-jeeva/login";
    } else {
      this.userName = JSON.parse(localStorage.getItem("user_details"))["name"];
    }
    window.headerComponent = this;
  }
  componentDidMount() {
    var thisController = this;
    var userRoles;

    if (localStorage.getItem("user_roles")) {
      userRoles = JSON.parse(localStorage.getItem("user_roles"));
      thisController.state.userRoles = userRoles;
      thisController.setState(this.state);
      thisController.setUserRole();
    } else {
      $.ajax({
        url: "/my-jeeva-api/user-account/me",
        method: 'POST',
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("access_token"),
        },
        success: (res) => {
          if (res.success === true) {
            localStorage.setItem("user_details", JSON.stringify(res.result.userDetails));
            localStorage.setItem("user_roles", JSON.stringify(res.result.userRoles));
            thisController.state.userRoles = res.result.userRoles;
            thisController.setState(this.state);
            thisController.userName = res.result.userDetails["name"];
            thisController.setUserRole();
          }
        },
        error: function (err) {
          console.error("Error fetching user roles:", err);
        },
      })
    }

    thisController.state.routeUrl = window.location.href;
    console.log(thisController.state.routeUrl);

    thisController.setupActivityListeners();
    thisController.resetTimer();
    document.addEventListener("click", thisController.handleOutsideClick);

  }

  componentWillUnmount() {
    clearTimeout(this.state.timeoutId);
    this.removeActivityListeners();
    document.removeEventListener("click", this.handleOutsideClick);

  }

  handleOutsideClick = () => {
    this.setState({ showAboutModal: false, showChangeLogModal: false, showDocumentationModal: false });
  };

  resetTimer = () => {
    if (this.state.timeoutId) clearTimeout(this.state.timeoutId);

    this.state.timeoutId = setTimeout(() => {
      console.log("User has been logged out due to inactivity.");
      localStorage.clear();
      logout();
    }, this.state.inactivityLimit);
  };

  setupActivityListeners = () => {
    const activityEvents = ["click", "mousemove", "keydown", "scroll"];
    activityEvents.forEach((event) =>
      window.addEventListener(event, this.resetTimer)
    );
  };

  removeActivityListeners = () => {
    const activityEvents = ["click", "mousemove", "keydown", "scroll"];
    activityEvents.forEach((event) =>
      window.removeEventListener(event, this.resetTimer)
    );
  };


  setUserRole = () => {
    var thisController = this;
    const selectedUser = JSON.parse(localStorage.getItem("selectedUser"));
    if (selectedUser) {
      thisController.state.selectedUser = selectedUser;
      thisController.state.selectedUserRole = `${thisController.formatRole(selectedUser.userRoleRecord.role)} - ${selectedUser.homeEntityName}`;
      thisController.setState(thisController.state);
      console.log("Restored Selected User:", thisController.state.selectedUser);
      console.log("The selected user role is : " + thisController.state.selectedUserRole);

    } else if (thisController.state.userRoles && thisController.state.userRoles.length > 0) {
      var userRole;
      userRole = thisController.state.userRoles[0];
      thisController.state.selectedUser = userRole;
      thisController.state.selectedUserRole = `${thisController.formatRole(userRole.userRoleRecord.role)} - ${userRole.homeEntityName}`
      thisController.setState(thisController.state);
    } else {
      console.log("No user roles available to select a default user.")
    }
  }
  handleRoleDropdownChange = (event) => {
    const selectedValue = event.target.value;
    const selectedUser = this.state.userRoles.find(
      (user) =>
        `${this.formatRole(user.userRoleRecord.role)} - ${user.homeEntityName}` === selectedValue
    );

    let user_details = JSON.parse(localStorage.getItem("user_details"));
    const roleChanged = !user_details || user_details.userRole !== selectedUser.userRoleRecord.role;
    if (user_details) {
      user_details.healthSystemId = selectedUser.userRoleRecord.healthSystemId;
      user_details.hospitalId = selectedUser.userRoleRecord.hospitalId;
      user_details.serviceLineId = selectedUser.userRoleRecord.serviceLineId
      user_details.userRole = selectedUser.userRoleRecord.role;
    }
    localStorage.setItem("user_details", JSON.stringify(user_details));
    localStorage.setItem("homeEntityName", selectedUser.homeEntityName);
    localStorage.setItem("currentScope", selectedUser.roleScopeValue);
    localStorage.setItem("selectedUser", JSON.stringify(selectedUser));
    window.SCOPE_VALUE.CURRENT = selectedUser.roleScopeValue;
    // Each role has its own set of tabs, so the page we are on may not exist for the new role
    // (e.g. the admin Treatment tab, /projectmgmt/procedure, has no route in the provider view).
    if (roleChanged) {
      window.location.href = "/my-jeeva/projectmgmt";
    } else {
      window.location.reload();
    }

  };
  formatRole = (role) => {
    return role
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  openLogoutPopUp = () => {

    confirmAlert({
      title: 'Confirm to Logout',
      message: 'Are you sure you want to logout ? ',
      buttons: [
        {
          label: 'Yes',
          onClick: () => logout()
        },
        {
          label: 'No',
        }
      ]
    });
  }

  aboutModalOpen = (e) => {
    e.stopPropagation();
    this.setState({ showAboutModal: true, showDocumentationModal: false }, () => {
      console.log("about modal is opened", this.state.showAboutModal);
    });
  }

  documentationModalOpen = (e) => {
    e.stopPropagation();
    this.setState({
      showAboutModal: false, showDocumentationModal: true
    });
  }

  handleCloseAboutModal = () => {
    this.setState({ aboutModal: false, }, () => {
      console.log("about modal is closed");
    });
  }

  documentationModalClose = () => {
    this.setState({ showDocumentationModal: false });
  }

  changeLogModalOpen = (e) => {
    e.stopPropagation();
    this.setState({ showChangeLogModal: true });
  };

  handleMouseEnter = () => {
    this.setState({ showAboutModal: true });
  };

  handleMouseLeave = () => {
    this.setState({ showAboutModal: false });
  };

  navigateToSec1 = () => {
    const id = "sec1";
    localStorage.setItem("id", id);
    if (this.state.routeUrl.includes("dev")) {
      window.open(`https://dev-admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    }
  };

  navigateToSec2 = () => {
    const id = "sec2";
    localStorage.setItem("id", id);
    if (this.state.routeUrl.includes("dev")) {
      window.open(`https://dev-admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    }
  };

  navigateToSec3 = () => {
    const id = "sec3";
    localStorage.setItem("id", id);
    if (this.state.routeUrl.includes("dev")) {
      window.open(`https://dev-admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    }
  };

  navigateToSec4 = () => {
    const id = "sec4";
    localStorage.setItem("id", id);
    if (this.state.routeUrl.includes("dev")) {
      window.open(`https://dev-admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");

    }
  };

  navigateToSec5 = () => {
    const id = "sec5";
    localStorage.setItem("id", id);
    if (this.state.routeUrl.includes("dev")) {
      window.open(`https://dev-admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    }
  };

  navigateToSec6 = () => {
    const id = "sec6";
    localStorage.setItem("id", id);
    if (this.state.routeUrl.includes("dev")) {
      window.open(`https://dev-admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    }
  };

  navigateToSec7 = () => {
    const id = "sec7";
    localStorage.setItem("id", id);
    if (this.state.routeUrl.includes("dev")) {
      window.open(`https://dev-admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");

    }
  };

  navigateToSec8 = () => {
    const id = "sec8";
    localStorage.setItem("id", id);
    if (this.state.routeUrl.includes("dev")) {
      window.open(`https://dev-admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    }
  };

  navigateToSec9 = () => {
    const id = "sec9";
    localStorage.setItem("id", id);
    if (this.state.routeUrl.includes("dev")) {
      window.open(`https://dev-admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");
    } else {
      window.open(`https://admin.myjeeva.net/my-jeeva/portal-overview`, "_blank", "noopener,noreferrer");

    }
  };

  render() {
    // const { data } = this.state;
    // const manageProjectColumns=[  ]

    const { showAboutModal, showChangeLogModal, showDocumentationModal } = this.state;


    return (

      <div className="wrapper" id="headerTab" style={{ marginTop: "2px" }}>

        {/*links for css files used for popup */}
        <link rel="stylesheet" href="assets/css/hamburger.css" />
        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/images/edit.svg" rel="stylesheet" />
        <link href="assets/images/add.svg" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popuame line in pythonps.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        <link href="assets/css/menu-drop-down.css" rel="stylesheet" />
        <link href="StyleSheet.css" rel="stylesheet" type="text/css" media="only screen" />
        <link href="MobileStyleSheet.css" rel="stylesheet" type="text/css" media="only screen and (max-device-width: 480px) , only screen and (-webkit-min-device-pixel-ratio: 2) , screen and (-webkit-device-pixel-ratio:1.5)" />
        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
        <link rel="stylesheet" type="text/css" href="//netdna.bootstrapcdn.com/bootstrap/3.1.1/css/bootstrap.min.css" />
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        <link href="assets/css/menu-items.css" rel="stylesheet" />
        <link href="assets/css/horizantal-line.css" rel="stylesheet" />
        {/* Theme style */}
        <link rel="stylesheet" href="assets/css/adminlte.css" />
        <link rel="stylesheet" href="assets/css/modal-style.css" />

        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        <link rel="stylesheet" href="assets/css/drop-down-alignment.css" />
        <link rel="stylesheet" href="plugins/select2/css/select2.min.css" />
        {/*links from create new project */}
        <link rel="stylesheet" href="assets/css/select2.min.css" />
        <link rel="stylesheet" href="assets/css/flaticon.css" />
        <link rel="stylesheet" href="assets/css/index.css" />
        <link rel="stylesheet" href="assets/css/modal-style.css" />
        <link href="assets/css/material.css" rel="stylesheet" />
        <link href="assets/css/bootstrap.min.css" rel="stylesheet" />
        <link href="react-table-without-pagination.css" rel="stylesheet" />
        <link href="assets/css/div-as-input-field.css" rel="stylesheet" />



        {/* Navigation bar */}
        <nav className="main-header navbar navbar-expand bg-white navbar-light border-bottom" id="nav" style={{ height: "75px" }}>

          <img src="assets/images/jeeva-logo.svg" style={{ height: "90px", width: "250px", marginRight: "0px" }} alt="AdminLTE Logo" className="brand-link" />


          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              width: "20%",
            }}
          >
            <div
              onClick={this.aboutModalOpen}
              style={{ position: "relative" }}
            >
              <h6
                className="mb-0"
                align="center"
                style={{
                  fontSize: "16px",
                  color: "#282a65",
                  marginRight: "0px",
                  cursor: "pointer",
                }}
              >
                About
              </h6>
              {showAboutModal && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: "0",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    padding: "10px",
                    zIndex: 1000,
                    width: "15vw",
                    height: "auto",
                    marginTop: "2.8vh",

                  }}
                >
                  <p style={{
                    margin: 0, fontSize: "14px",
                    // color: "#0094c8"
                  }}>
                    MyJEEVA Provider Portal
                  </p>
                  <p style={{ margin: 0, fontSize: "14px", marginTop: "1vh" }}>
                    Version 3.4.3
                  </p>
                  <Link
                    onClick={() => this.state.routeUrl.includes("dev") ?
                      window.open("https://dev-admin.myjeeva.net/my-jeeva/change-log", "_blank", "noopener,noreferrer")
                      :
                      window.open("https://admin.myjeeva.net/my-jeeva/change-log", "_blank", "noopener,noreferrer")
                    }

                  >
                    <p
                      style={{
                        margin: 0,
                        fontSize: "14px",
                        color: "#282a65",
                        cursor: "pointer",
                        marginTop: "1vh"
                      }}
                    // onClick={this.changeLogModalOpen}
                    >
                      Change Log
                    </p>
                  </Link>

                  <p style={{ margin: 0, fontSize: "14px", color: "#0094c8", marginTop: "1vh" }}>
                    <Link
                      to="#"
                      onClick={() => window.open("http://jeevacare.ai", "_blank", "noopener,noreferrer")}
                      style={{ color: "#282a65", textDecoration: "none" }}
                    >
                      Brought to you by JEEVA Care, Inc.
                    </Link>
                  </p>
                </div>
              )}
            </div>


            <h6
              className="mb-0"
              align="center"
              onClick={this.documentationModalOpen}
              // style={{ position: "relative" }}
              style={{
                fontSize: "16px", color: "#282a65", marginRight: "0px", position: "relative",
                cursor: "pointer",
              }}
            >
              Documentation
            </h6>

            {showDocumentationModal && (
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: "absolute",
                  top: "100%",
                  // left: "0",
                  backgroundColor: "white",
                  border: "1px solid #ccc",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                  padding: "10px",
                  zIndex: 1000,
                  width: "15vw",
                  height: "auto",
                  marginLeft: "32vh"

                }}
              >
                <Link
                  onClick={this.navigateToSec1}

                >
                  <p style={{
                    margin: 0, fontSize: "14px",
                    color: "#282a65"
                  }}>
                    Provider Portal overview
                  </p>
                </Link>


                <Link
                  onClick={this.navigateToSec3}

                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "14px",
                      color: "#282a65",
                      cursor: "pointer",
                      marginTop: "1vh"
                    }}
                  >
                    Engage patients
                  </p>
                </Link>

                <p style={{ margin: 0, fontSize: "14px", color: "#0094c8", marginTop: "1vh" }}>
                  <Link
                    onClick={this.navigateToSec4}
                    style={{ color: "#282a65", textDecoration: "none" }}
                  >
                    Identify patients at risk
                  </Link>
                </p>
                <p style={{ margin: 0, fontSize: "14px", color: "#0094c8", marginTop: "1vh" }}>
                  <Link
                    onClick={this.navigateToSec5}
                    style={{ color: "#282a65", textDecoration: "none" }}
                  >
                    Create or modify a treatment
                  </Link>
                </p>
                <p style={{ margin: 0, fontSize: "14px", color: "#0094c8", marginTop: "1vh" }}>
                  <Link
                    onClick={this.navigateToSec6}
                    style={{ color: "#282a65", textDecoration: "none" }}
                  >
                    For MyJEEVA Administrators
                  </Link>
                </p>
                <p style={{ margin: 0, fontSize: "14px", color: "#0094c8", marginTop: "1vh" }}>
                  <Link
                    onClick={this.navigateToSec7}
                    style={{ color: "#282a65", textDecoration: "none" }}
                  >
                    Technical requirements
                  </Link>
                </p>
              </div>

            )}


            {/* <h6
              className="mb-0"
              align="center"
              style={{ fontSize: "16px", color: "#282a65", marginRight: "0px" }}
            >
              Support
            </h6> */}
          </div>

          <ul className="navbar-nav ml-auto" style={{ alignItems: "center" }}>
            <select
              style={{
                height: "2.5em",
                margin: "0px 1em",
                padding: "0px 0.5em",
                borderRadius: "5px",
              }}
              value={this.state.selectedUserRole}
              onChange={this.handleRoleDropdownChange}
            >
              <option value="" disabled hidden>Select Role</option>
              {this.state.userRoles.map(user => (
                <option
                  key={user.userRoleRecord.id}
                  value={`${this.formatRole(user.userRoleRecord.role)} - ${user.homeEntityName}`}
                >{`${this.formatRole(user.userRoleRecord.role === "PHYSICIAN" ? "PROVIDER" : user.userRoleRecord.role)} - ${user.homeEntityName}`}</option>
              ))}
            </select>
            {/* Notifications Dropdown Menu */}
            <table>
              <tr>
                {/* Show "Welcome" and "Logout" elements only on screens larger than 375px */}
                <td className="greet">
                  <li>
                    <span><b>Welcome</b><h5>{this.userName}!</h5></span>
                  </li>
                </td>
                <td></td><td></td>
                <td className="greet">
                  <li className="nav-item col-sm-2">
                    <span><img title="Logout" onClick={() => this.openLogoutPopUp()}
                      // this.setState({ 
                      //   hideLogoutConfirmation: true 
                      //   })} 
                      style={{ height: "40px", width: "40px", marginTop: '22px' }} src="./assets/images/power.svg" alt="" /></span>
                  </li>
                </td>
                {/* Show hamburger menu only on screens smaller than 375px */}
                <td className="d-block d-md-none">
                  <li>
                    <span><HamburgerMenu /></span>
                  </li>
                </td>
              </tr>
            </table>
          </ul>

        </nav>

        {/* end of navigation bar */}


        {/*-----------------------------------My Account Page Popup------------------------*/}
        {/* <DialogComponent width='200px' style={{ position: "fixed" }} animationSettings={this.settings}
          header='Log out?' showCloseIcon={true} buttons={this.logoutButton}
          ref={dialog => this.dialogInstance = dialog} target='#headerTab'
          visible={this.state.hideLogoutConfirmation} close={this.dialogClose}>
          <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;Are you sure you want to log out?</DialogComponent> */}


      </div >


    );
  }
}

export default Header;


// WEBPACK FOOTER //
// src/my-jeeva/header/Header.js